import React from "react";
import NavigationBar from "../../General/NavigationBar/NavigationBar";
import SafetySidebar from "../SafetySidebar/SafetySidebar";

const SafetyLayout = ({ children }: { children: React.ReactNode }) => (
  <NavigationBar sidebar={<SafetySidebar />}>{children}</NavigationBar>
);

export default SafetyLayout;

